import t from '../../../translation';

const backSpecialWonderconRed = {
  text: t('backSpecialWonderconRedText'),
  notes: t('backSpecialWonderconRedNotes'),
  value: 0,
  mystery: 'wondercon',
};

const backSpecialWonderconBlack = {
  text: t('backSpecialWonderconBlackText'),
  notes: t('backSpecialWonderconBlackNotes'),
  value: 0,
  mystery: 'wondercon',
};

const bodySpecialWonderconRed = {
  text: t('bodySpecialWonderconRedText'),
  notes: t('bodySpecialWonderconRedNotes'),
  value: 0,
  mystery: 'wondercon',
};

const bodySpecialWonderconGold = {
  text: t('bodySpecialWonderconGoldText'),
  notes: t('bodySpecialWonderconGoldNotes'),
  value: 0,
  mystery: 'wondercon',
};

const bodySpecialWonderconBlack = {
  text: t('bodySpecialWonderconBlackText'),
  notes: t('bodySpecialWonderconBlackNotes'),
  value: 0,
  mystery: 'wondercon',
};

const eyewearSpecialWonderconRed = {
  text: t('eyewearSpecialWonderconRedText'),
  notes: t('eyewearSpecialWonderconRedNotes'),
  value: 0,
  mystery: 'wondercon',
};

const eyewearSpecialWonderconBlack = {
  text: t('eyewearSpecialWonderconBlackText'),
  notes: t('eyewearSpecialWonderconBlackNotes'),
  value: 0,
  mystery: 'wondercon',
};

export {
  backSpecialWonderconRed,
  backSpecialWonderconBlack,
  bodySpecialWonderconRed,
  bodySpecialWonderconGold,
  bodySpecialWonderconBlack,
  eyewearSpecialWonderconRed,
  eyewearSpecialWonderconBlack,
};
